import PropTypes from 'prop-types'
import TlPaymentMethodsApiV2 from 'api/v2/admins/tl-payment-methods-api-v2'
import { SelectSearchField } from 'components'
import { useFormikContext } from 'formik'
import React, { useState } from 'react'

const propTypes = {
  name     : PropTypes.string,
  label    : PropTypes.string,
  required : PropTypes.bool,
  formText : PropTypes.string,
  filters  : PropTypes.object
}

/**
 * Search field to select warehouse location by its name
 * @param {Object} props - props object
 */
const PaymentMethodSelectSearchField = ({
  name,
  label,
  required,
  formText,
  filters = {},
  ...props
}) => {
  const [ tlPaymentMethods, setTlPaymentMethods ] = useState([])
  const [ isLoading, setIsLoading ]               = useState(true)
  const { setFieldError, setFieldTouched }        = useFormikContext()

  var searchTimeout = null

  // search TlBanks by bank name
  const getTlPaymentMethods = (name) => {
    setIsLoading(true)

    const tableState        = null
    const additionalFilters = {
      name: name,
      ...filters
    }

    TlPaymentMethodsApiV2.index({ tableState, additionalFilters })
      .then((response) => {
        setTlPaymentMethods(response.data.tl_payment_methods)
      })
      .catch(() => {
        setFieldError(name, 'Searching TL Payment Methods error')
        setFieldTouched(name, true, false)
      })
      .finally(() => setIsLoading(false))
  }

  // The presentation of option label when dropdown is open
  const getOptionLabel = (option) => (
    <>
      <span className='mr-3'>{ option.category }</span>
      <span className='mr-3'>{ '-' }</span>
      <span className='mr-3'>{ option.name }</span>
    </>
  )

  // handler to search sellers
  const handleSelectSearchOnChange = (event) => {
    const searchText = event.target.value
    if (searchTimeout) clearTimeout(searchTimeout)
    searchTimeout = setTimeout(() => {
      getTlPaymentMethods(searchText)
    }, 700)
  }

  return (
    <SelectSearchField
      name={ name }
      label={ label }
      placeholder='Search with Bank Name'
      dataList={ tlPaymentMethods }
      onSearchChange={ (handleSelectSearchOnChange) }
      getOptionLabel={ getOptionLabel }
      isLoading={ isLoading }
      required={ required }
      formText={ formText }
      { ...props }
    />
  )
}

PaymentMethodSelectSearchField.propTypes = propTypes

export default PaymentMethodSelectSearchField
